import { Link } from "@/i18n/navigation";
import { useWindowWidth } from "@/shared/lib/hooks/useWindowSize";
import { useAuth } from "@/shared/providers/AuthProvider";

const PricingRequest = () => {
  const width = useWindowWidth();
  const { user } = useAuth();

  return (
    <div
      className={
        "mt-[30px] flex flex-col items-center justify-center rounded-lg border-[2px] border-primary px-[24px] pb-[48px] pt-[48px] sm:pt-[48px] lg:mt-[160px] lg:pb-[32px] lg:pt-[60px]"
      }
    >
      <h2
        className={
          "w-full text-center text-[28px] font-[600] text-primary sm:text-heading3 lg:font-[800]"
        }
      >
        {width && width >= 640
          ? "일단 한번 부담없이 써보세요!"
          : "일단 무료로 써보세요!"}
      </h2>
      {width && width >= 640 ? (
        <p className={"w-full text-center text-primary"}>
          Winging에 가입하면 크레딧이 제공됩니다.
          <br />
          제공된 크레딧으로 한달간 Winging을 체험해 보세요!
        </p>
      ) : (
        <p className={"text-body1 font-[600] text-primary sm:text-title2"}>
          {" "}
          Winging을 무료로 시작해 보세요.
        </p>
      )}
      <Link
        href={user ? "/dashboard/demo" : "/auth/sign-in"}
        className={
          "mt-[16px] flex h-[40px] w-[152px] items-center justify-center rounded-md border-[2px] border-primary pt-[2px] font-[600] text-primary"
        }
        style={{
          boxShadow: "0 4px 4px 0 rgba(0, 0, 0, 0.25)",
        }}
      >
        {width && width >= 640 ? "체험 시작하기" : "무료로 시작하기"}
      </Link>
    </div>
  );
};

export default PricingRequest;
